const PubSub = require('underpub-js');
const Masonry = require('masonry-layout');

const designShowcaseListing = function(options) {
  this.options = {
    $el: false,
  };

  $.extend(true, this.options, options);

  this.data = {
    baseClass: 'comp-DesignShowcaseListing',
    hasLoaded: false,
  };
};

designShowcaseListing.prototype.init = function() {
  const self = this;

  self.$grid = self.options.$el.find(`.${self.data.baseClass}__items`);
  self.data.itemClass = `.${self.data.baseClass}__items__item`;
  self.$item = self.options.$el.find(self.data.itemClass);

  self.initGrid();
};

designShowcaseListing.prototype.initGrid = function() {
  const self = this;

  new Masonry(self.$grid[0], {
    itemSelector: self.data.itemClass,
    transitionDuration: '0.3s',
  });
};

module.exports = designShowcaseListing;
